export const VECTOR_FEATURE_TYPE_SOURCE = 'source';
